import React from 'react';
import { Link } from 'react-router-dom';
import StonewallLogo from './StonewallLogo';

const Footer = () => {
  return (
    <footer className="bg-gray-300 dark:bg-gray-800 py-5 mt-auto border-t border-gray-400 dark:border-gray-700">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-5 lg:px-7">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2 flex-shrink-0">
            <StonewallLogo className="h-7 w-7" />
            <p className="text-sm font-bold text-gray-900 dark:text-white">Stonewall Invoicing</p>
          </div>
          <div className="flex items-center gap-5 text-sm text-gray-600 dark:text-gray-400">
            <Link to="/features" className="hover:text-gray-900 dark:hover:text-white">Features</Link>
            <Link to="/pricing" className="hover:text-gray-900 dark:hover:text-white">Pricing</Link>
            <Link to="/downloads" className="hover:text-gray-900 dark:hover:text-white">Download</Link>
            <Link to="/documentation" className="hover:text-gray-900 dark:hover:text-white">Documentation</Link>
            <Link to="/about" className="hover:text-gray-900 dark:hover:text-white">About Us</Link>
            <Link to="/contact" className="hover:text-gray-900 dark:hover:text-white">Contact</Link>
            <Link to="/privacy" className="hover:text-gray-900 dark:hover:text-white">Privacy Policy</Link>
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-500 flex-shrink-0">&copy; {new Date().getFullYear()} Stonewall Invoicing LLC &mdash; 1500 N Grant Street, Ste C, Denver, CO 80203</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
